export enum ContentActionButtonIds {
  PLAY = 'playButton',
  PASSPORT = 'passport',
  ADD_TO_WATCHLIST = 'add_to_watchlist',
  IN_WATCHLIST = 'in_watchlist',
  MORE_EPISODES = 'moreEpisodes',
  PREVIEW = 'preview',
}

export enum ContentActionButtonFocusKeys {
  PLAY = 'PLAY_BUTTON',
  PASSPORT = 'PASSPORT_BUTTON',
  MY_LIST = 'MY_LIST_BUTTON',
  MORE_EPISODES = 'MORE_EPISODES_BUTTON',
  PREVIEW = 'PREVIEW_BUTTON',
}

export enum ContentActionButtonLabel {
  PLAY = 'Play',
  PASSPORT = 'Get Passport',
  RESUME = 'Resume',
  MY_LIST = 'My List',
  MORE_EPISODES = 'More Episodes',
  PREVIEW = 'Preview',
}

export type ContentActionButton = {
  id: ContentActionButtonIds
  label: ContentActionButtonLabel
  focusKey: ContentActionButtonFocusKeys
  onPressAction: (() => void) | (() => Promise<void>)
}

export type WatchlistContent = {
  cid: string
  images: {
    'asset-mezzanine-16x9': string
  }
  contentType: string
  item_type: 'video'
  flags: { is_mvod: boolean }
  duration: number
  seconds_watched: number
  slug: string
  title: string
  showTitle: string
  url: string
  video_type: string
  parent?: any
}

export type ContentActionButtons = ContentActionButton[]
